import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-reservacion-historial',
  templateUrl: './reservacion-historial.component.html',
  styleUrls: ['./reservacion-historial.component.scss'],
})
export class ReservacionHistorialComponent {
  @Input() reservacion: any;
  public cotizacion: any;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly location: Location
  ) {
    this.reservacion = JSON.parse(
      sessionStorage.getItem('reservations') || '{}'
    ).find(
      (reservation: any) => reservation.id == this.route.snapshot.params['id']
    );
  }

  ngOnInit(): void {
    this.cotizacion = {
      from: this.reservacion.transaction[0].idCurrencyPayment,
      to: this.reservacion.transaction[0].idCurrencyReceives,
      in: this.reservacion.transaction[0].amountPayment,
      out: this.reservacion.transaction[0].amountReceives,
    };
  }

  atras() {
    this.location.back();
  }
}
